export const COOKIE_KEY = "ehbferuifbeifhiue",
  GLOBAL_URL = "http://mindeate.com/api/v1/",
  SOCKET_URL = "ws://mindeate.com:5000";
